'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { AnimatedSubtitle } from '@/modules/home/components/animated-subtitle';
import { getBuildNetworkSectionV2CellBorderClass } from '@/modules/home/lib/build-network-section-v2-cell-border';
import { BUILD_NETWORK_V2_FEATURES } from '@/modules/home/lib/constants';
import { AchraOrbitAnimation } from '../achra-orbit-animation';
import { CtaBlock } from './cta-block';
import { FeatureBlock } from './feature-block';
function BuildNetworkSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="mx-auto mb-8 max-w-2xl text-center md:mb-10"><h2 id="build-network-v2-heading" className="text-foreground text-3xl font-semibold tracking-tight text-balance sm:text-4xl">Build your Network with Achra</h2><AnimatedSubtitle className="text-foreground/80 mt-4 text-lg leading-relaxed text-pretty">Powering the next generation of networked organizations.</AnimatedSubtitle></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 items-stretch md:grid-cols-2 lg:grid-cols-4">{BUILD_NETWORK_V2_FEATURES.map(_temp)}<div className={cn(getBuildNetworkSectionV2CellBorderClass(3), "h-full")}><CtaBlock /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="relative z-10 w-full overflow-x-clip pb-16 sm:pb-20 lg:pb-24" aria-labelledby="build-network-v2-heading"><div className="container">{t0}<div className="border-border bg-card overflow-hidden rounded-3xl border shadow-xs">{t1}<div className="border-border bg-background/40 border-t"><AchraOrbitAnimation /></div></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(feature, index) {
  return <div key={feature.variant} className={cn(getBuildNetworkSectionV2CellBorderClass(index), "h-full")}><FeatureBlock feature={feature} /></div>;
}
export { BuildNetworkSection };